var _defs, _path, _path2, _text, _path3, _path4, _path5, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsApmPeriodsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 215.46 303.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n\n      .cls-1, .cls-2 {\n        fill: #fcfcfc;\n      }\n\n      .cls-3 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-4 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-2 {\n        font-family: Calibri-Bold, Calibri;\n        font-size: 72px;\n        font-weight: 500;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-5 {\n        letter-spacing: 0em;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.25,53.86H48.29c-1.33,0-2.41-1.08-2.41-2.41s1.08-2.41,2.41-2.41h102.96c1.33,0,2.41,1.08,2.41,2.41s-1.08,2.41-2.41,2.41Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M145.23,53.86H53.71c-1.33,0-2.41-.73-2.41-1.62V4.02c0-.9,1.08-1.62,2.41-1.62h91.52c1.33,0,2.41.73,2.41,1.62v48.22c0,.9-1.08,1.62-2.41,1.62ZM56.12,50.61h86.71V7.64H56.12v42.97Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(.51 302.39)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 0,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 42.71,
    y: 0
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 79.34,
    y: 0
  }, "M"))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.61,55.66c-2,0-3.61-1.62-3.61-3.61v-4.52c0-6.59,2.67-12.84,7.52-17.59,4.86-4.77,11.28-7.4,18.07-7.4h3.31c2,0,3.61,1.62,3.61,3.61s-1.62,3.61-3.61,3.61h-3.31c-9.96,0-18.36,8.13-18.36,17.76v4.52c0,2-1.62,3.61-3.61,3.61Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M175.34,169.17c-2,0-3.61-1.62-3.61-3.61V47.54c0-9.63-8.41-17.76-18.36-17.76h-5.12c-2,0-3.61-1.62-3.61-3.61s1.62-3.61,3.61-3.61h5.12c6.79,0,13.21,2.63,18.07,7.4,4.85,4.76,7.52,11.01,7.52,17.59v118.02c0,2-1.62,3.61-3.61,3.61Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.04,245.94H48.59c-13.82,0-25.05-11.05-25.57-25.16-.07-1.99,1.48-3.67,3.48-3.74,2.02-.07,3.67,1.48,3.74,3.48.38,10.2,8.43,18.2,18.35,18.2h70.45c2,0,3.61,1.62,3.61,3.61s-1.62,3.61-3.61,3.61Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.83,224.11H16.21C7.34,224.11.12,216.89.12,208.02v-126.56c0-10.57,8.6-19.17,19.17-19.17h140.57c10.57,0,19.17,8.6,19.17,19.17v94.03c0,2-1.62,3.61-3.61,3.61s-3.61-1.62-3.61-3.61v-94.03c0-6.58-5.36-11.94-11.94-11.94H19.29c-6.58,0-11.94,5.36-11.94,11.94v126.56c0,4.89,3.98,8.86,8.86,8.86h110.62c2,0,3.61,1.62,3.61,3.61s-1.62,3.61-3.61,3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M175.41,97.7H3.73c-2,0-3.61-1.62-3.61-3.61v-17.15c0-8.08,6.57-14.65,14.65-14.65h149.6c8.08,0,14.65,6.57,14.65,14.65v17.15c0,2-1.62,3.61-3.61,3.61ZM7.34,90.47h164.45v-13.53c0-4.09-3.33-7.43-7.43-7.43H14.77c-4.09,0-7.43,3.33-7.43,7.43v13.53Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 60.15,
    y: 109.96,
    width: 22.61,
    height: 22.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 96.43,
    y: 109.46,
    width: 22.61,
    height: 22.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.38,
    y: 145.67,
    width: 22.61,
    height: 22.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 60.15,
    y: 146.18,
    width: 22.61,
    height: 22.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 96.43,
    y: 145.67,
    width: 22.61,
    height: 22.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.38,
    y: 182.6,
    width: 22.61,
    height: 22.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 60.15,
    y: 183.11,
    width: 22.61,
    height: 22.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 96.43,
    y: 182.6,
    width: 22.61,
    height: 22.61
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 132.7,
    y: 109.46,
    width: 22.61,
    height: 22.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 132.7,
    y: 145.67,
    width: 22.61,
    height: 22.61
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M169,263.4c-25.3,0-45.89-20.59-45.89-45.89s20.59-45.89,45.89-45.89,45.89,20.59,45.89,45.89-20.59,45.89-45.89,45.89ZM169,178.84c-21.32,0-38.67,17.35-38.67,38.67s17.35,38.67,38.67,38.67,38.67-17.35,38.67-38.67-17.35-38.67-38.67-38.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M168.58,220.34c-1.33,0-2.41-1.08-2.41-2.41v-31.6c0-1.33,1.08-2.41,2.41-2.41s2.41,1.08,2.41,2.41v31.6c0,1.33-1.08,2.41-2.41,2.41Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 181.39,
    y1: 233.31,
    x2: 168.58,
    y2: 217.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M181.39,235.72c-.69,0-1.37-.29-1.85-.87l-12.81-15.37c-.85-1.02-.71-2.54.31-3.39,1.02-.85,2.54-.71,3.39.31l12.81,15.37c.85,1.02.71,2.54-.31,3.39-.45.38-1,.56-1.54.56Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsApmPeriodsWhite);
export default __webpack_public_path__ + "static/media/Icons_APMPeriods_White.e75c5cd6b9d4ffee4ce53c4dd1178f66.svg";
export { ForwardRef as ReactComponent };